export const blockIconsPhotoandimageImageSearchNew = (
	<span className='material-symbols-outlined'>image_search</span>
);
